<template>
  <div class="process-timer">
    <vue-apex-charts
      width="500"
      type="radialBar"
      :options="chartOptions"
      :series="[processProgress]"></vue-apex-charts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'ProcessTimer',
  props: {
    label: String,
    time: Number,
  },
  data() {
    return {
      processProgress: 0,
      processInterval: undefined,
      chartOptions: {
        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            },
            dataLabels: {
              name: {},
              value: {
                formatter: val => `${parseInt((val / this.processSteps), 10)} sec`,
              },
            },
          },
        },
        labels: [this.label],
      },
    };
  },
  computed: {
    processSteps() {
      return 100 / this.time;
    },
  },
  methods: {
    updateSeries() {
      this.processInterval = setInterval(
        () => {
          this.processProgress = this.processProgress + this.processSteps;
          if (this.checkProcessDone()) {
            this.stopInterval();
          }
        }, 1000,
      );
    },
    stopInterval() {
      clearInterval(this.processInterval);
    },
    checkProcessDone() {
      return this.processProgress >= 100;
    },
  },
  created() {
    this.updateSeries();
  },
  beforeDestroy() {
    this.stopInterval();
  },
  components: {
    VueApexCharts,
  },
};
</script>

<style lang="scss">
  .process-timer {

  }
</style>
